import { render } from "./CustomScrollbar.vue?vue&type=template&id=20a2ef26"
import script from "./CustomScrollbar.vue?vue&type=script&lang=js"
export * from "./CustomScrollbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__